import React from "react";
import { BlogLayout } from "@/components/layout/BlogLayout";
import { TableOfContents } from "@/components/blog/TableOfContents";
import { PostHeader } from "@/components/blog/PostHeader";
import { PostIntroSection } from "@/components/blog/PostIntroSection";
import { novedadesIaMayo2026TableOfContents } from "./novedades-ia-mayo-2026/tableOfContents";
import { ArticleContent } from "./novedades-ia-mayo-2026/ArticleContent";
import { RelatedArticles } from "@/components/blog/RelatedArticles";
import { Breadcrumbs } from "@/components/shared/Breadcrumbs";
import { UpdateDate } from "@/components/shared/UpdateDate";
import novedadesIaImage from "@/assets/blog-novedades-ia-mayo-2026.jpg";

export function NovedadesIaMayo2026Post() {
  return (
    <>
      <PostHeader
        title="Novedades IA mayo 2026: GPT-5.5, iOS 27 con Claude y Gemini | SEOEVOLUTION"
        description="Análisis de las novedades de la IA en mayo 2026: GPT-5.5, Apple abre iOS 27 a Claude y Gemini, memoria portable y qué implica para empresas y SEO."
        keywords="GPT-5.5, OpenAI, Claude, Gemini, Apple Intelligence, iOS 27, novedades IA 2026, GEO, agentes IA"
        author="Ángel Ruz"
        canonicalUrl="https://agenciaseoevolution.com/blog/novedades-ia-mayo-2026"
      />

      <BlogLayout>
        <article className="py-16 relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-seo-darkBlue to-seo-dark opacity-90"></div>
          <div className="container mx-auto px-4 md:px-6 relative z-10">
            <div className="max-w-5xl mx-auto">
              <Breadcrumbs />

              <PostIntroSection
                category="INTELIGENCIA ARTIFICIAL"
                title="Novedades de la IA en mayo 2026: GPT-5.5, Apple abre iOS 27 a Claude y Gemini"
                date="8 Mayo, 2026"
                author="Ángel Ruz"
                imageUrl={novedadesIaImage}
                imageAlt="Novedades de la IA en mayo de 2026: GPT-5.5, Claude, Gemini y Apple Intelligence"
                description="Las últimas semanas han redibujado el mapa de la inteligencia artificial. OpenAI ha presentado GPT-5.5 con capacidades agénticas reales, Apple abre iOS 27 a Claude y Gemini junto a ChatGPT, y Google permite ya migrar la memoria de otras IAs a Gemini. Tres movimientos que confirman una nueva era: multimodelo, autónoma y embebida en el sistema operativo."
              />

              <UpdateDate
                date="Mayo 2026"
                updatesSection={
                  <div>
                    <p className="font-semibold mb-2">Resumen de las últimas novedades:</p>
                    <ul className="list-disc list-inside space-y-1 text-sm">
                      <li>OpenAI lanza GPT-5.5 y GPT-5.5 Pro (23 abril 2026)</li>
                      <li>Apple permitirá elegir Claude o Gemini en iOS 27</li>
                      <li>Gemini importa memoria de ChatGPT y Claude</li>
                      <li>Instrucciones permanentes en Gemini para Google Docs</li>
                    </ul>
                  </div>
                }
              />

              <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                <div className="lg:col-span-2 bg-seo-dark/50 rounded-xl p-6 shadow-lg backdrop-blur-xs">
                  <ArticleContent />
                  <RelatedArticles currentSlug="/novedades-ia-mayo-2026" category="Inteligencia Artificial" />
                </div>

                <div className="lg:col-span-1">
                  <TableOfContents items={novedadesIaMayo2026TableOfContents} />
                </div>
              </div>
            </div>
          </div>
        </article>
      </BlogLayout>
    </>
  );
}
